export type Format = Intl.ListFormatType | 'only-comma'

/**
 * Convert an array of words to a sentence.
 *
 * @param words - Array of words to be converted to a sentence.
 * @param format - The format of the list.
 * - `'conjunction'`: Uses the conjunction format (e.g., `foo, bar e baz`).
 * - `'disjunction'`: Uses the disjunction format (e.g., `foo, bar ou baz`).
 * - `'unit'`: Uses the unit format (e.g., `foo bar baz`).
 * - `'only-comma'`: Uses only commas to separate the words (e.g., `foo, bar, baz`).
 * @returns The sentence.
 *
 * @example
 * ```ts
 * toSentence(['foo', 'bar', 'baz'], 'conjunction') // 'foo, bar e baz'
 * toSentence(['foo', 'bar', 'baz'], 'disjunction') // 'foo, bar ou baz'
 * toSentence(['foo', 'bar', 'baz'], 'unit') // 'foo bar baz'
 * toSentence(['foo', 'bar', 'baz'], 'only-comma') // 'foo, bar, baz'
 * ```
 */
export function toSentence(words: string[], format: Format = 'conjunction'): string {
  if (format === 'only-comma') return words.join(', ')
  const formatter = new Intl.ListFormat('pt-BR', {
    style: format === 'unit' ? 'narrow' : 'long',
    type: format
  })
  return formatter.format(words)
}
